import { includedPropList } from "../../../pages/activityBuilder/modules/landUseChanges/landUseChange";
import type {
	LandUseChangeResponse,
	ModuleFull,
} from "../../../pages/activityBuilder/modules/landUseChanges/landUseChangeTypes";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createEntriesGetApi, createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "LandUseChange";
const TAG: TagTypes = "LandUseChange";
const ENDPOINT = FEModulesObj[FEModules.LandUseChange].path;

const transformResponse = (response: LandUseChangeResponse) => transformModuleResponse<LandUseChangeResponse, ModuleFull>({
	response,
	includedPropList
})

const landUseChangeApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	transformResponse,
})

const publicLandUseChangeApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: {}, // Land use change doesn't have tier two data
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, LandUseChangeResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	transformUpdatePayload,
	includesLandUseChange: true
})

export const {
	useGetLandUseChangeQuery,
} = landUseChangeApiSlice;

export const {
	useGetLandUseChangeQuery: usePublicGetLandUseChangeQuery,
} = publicLandUseChangeApiSlice;

export const {
	useUpdateLandUseChangeMutation,
} = mutationApiSlice;

const transformResponseByActivityId = (response: LandUseChangeResponse[]) => transformResponse(response[0])
const otherApis = createEntriesGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: "LandUseChangeByActivityId",
	tag: TAG,
	transformResponse: transformResponseByActivityId,
})

const publicOtherApis = createEntriesGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: "LandUseChangeByActivityId",
	tag: TAG,
	transformResponse: transformResponseByActivityId,
})


export const {
	useGetLandUseChangeByActivityIdQuery,
} = otherApis;

export const {
	useGetLandUseChangeByActivityIdQuery: usePublicGetLandUseChangeByActivityIdQuery,
} = publicOtherApis;